<script setup lang="ts">
import { inject, ref } from 'vue'

import convertToUTC from '@/lib/convertToUTC'
import type { ExtendedEvent, ExtendedStore } from '@/types'

const props = defineProps<{
  place: ExtendedStore & ExtendedEvent
}>()

const formattedDate = ref('')

if (props.place.properties.events !== undefined) {
  if (props.place.properties.events[0].startAt !== '') {
    formattedDate.value = convertToUTC(props.place.properties.events[0].startAt)
  }
}

const [date, time] = formattedDate.value.split(' ')

const brand = inject('BRAND')

const address = props.place.properties.address.replace(
  `, ${props.place.properties.city}`,
  '',
)
</script>
<template>
  <div
    class="mx-3 cursor-pointer rounded-xl border px-5 py-3 text-center font-sans text-black hover:bg-primary-light"
    :class="{
      'border-gray-light': brand === 'satch',
      'border-gray-300': brand !== 'satch',
    }"
  >
    <div
      v-if="date && time"
      class="flex justify-center gap-3 pt-0.5 font-sans text-base md:text-sm"
    >
      <p>{{ date }}</p>
      <p>{{ time }} {{ $t('time') }}</p>
    </div>
    <div
      v-if="
        props.place.properties.events !== undefined &&
        props.place.properties.events.length > 1
      "
      class="pb-2"
      :class="{
        'text-gray-medium': brand === 'satch',
        'text-gray-500 md:text-sm': brand !== 'satch',
      }"
    >
      <p>+ {{ $t('moreEvents') }}</p>
    </div>
    <div class="flex flex-col md:gap-1.5 md:pb-2">
      <p class="text-base md:text-base">
        {{ props.place.properties.name }}
      </p>
      <div
        class="flex flex-col items-center justify-center gap-1 font-sans text-base md:gap-0 md:text-sm"
        :class="{
          'text-gray-medium': brand === 'satch',
          'text-gray-500': brand !== 'satch',
        }"
      >
        <p>
          {{ address }}
        </p>
        <p class="md:pt-1.5">
          {{ props.place.properties.city }}
        </p>
      </div>
    </div>

    <p
      v-if="props.place.geometry.distance"
      class="font-sans text-black text-sm"
      :class="{
        'md:text-2xs': brand === 'satch',
        'md:text-sm': brand !== 'satch',
      }"
    >
      {{ props.place.geometry.distance.toFixed(2) }} km
    </p>
  </div>
</template>
